import React from 'react'
import renderRoutes from '../../../../../routes/renderRoutes'
import { connect } from 'react-redux'

// Components Global
import Window from '../../../../../components/Windows/Window'
import { LayoutsTwo, Layouts1, Layouts2 } from '../../../../../components/LayoutsTwoResponsive'
import MenuSidebarResponsive from '../../../../../components/MenuSidebarResponsive'

// Components Purchases
import RubberContractCreateAndUpdateModal from '../components/RubberContractCreateAndUpdateModal'


const menuItems = (params) => {
  const { username } = params
  const path = `/${username}/rubber-contracts`
  const itemMain = [
    {
      name: 'สัญญาขายล่วงหน้า',
      title: true
    },
    {
      name: 'ทั้งหมด',
      nameShort: 'ทั้งหมด',
      icon: 'assignment',
      link: `${path}/all/all`,
      searchLinkActive: `${path}/all/`
    },
    {
      name: 'ยางแผ่นดิบ',
      nameShort: 'ยางแผ่นดิบ',
      iconFa: 'fas fa-layer-group',
      link: `${path}/rubber-sheet/all`,
      searchLinkActive: `${path}/rubber-sheet/`
    },
    {
      name: 'ยางแผ่นรวมควัน',
      nameShort: 'ยางแผ่นรวมควัน',
      iconFa: 'fas fa-dumpster-fire',
      link: `${path}/ribbed-smoked-sheet/all`,
      searchLinkActive: `${path}/ribbed-smoked-sheet/`
    }
  ]

  return itemMain
}

const RubberContractsMenuContainer = (props) => {
  const { business, setting, location, route, match, windowModal, closeWindowModal, history } = props
  const title = "ขายยางแผ่นล่วงหน้า"
  const titleIcon = require(`../../../Businesses/resources/icons/rubber-sheet-contract.png`)

  return (
    <Window
      title={title}
      titleIcon={titleIcon}
      linkClose={`/${match.params.username}`}
      windowModal={windowModal}
      closeWindowModal={closeWindowModal}
      history={history}
      linkHelp="">

      <LayoutsTwo>
        <Layouts1>
          <MenuSidebarResponsive
            btnAddModal={{
              modalId: 'rubberContractCreateAndUpdateModal',
              text: `เพิ่มสัญญาขายล่วงหน้า`,
            }}
            items={menuItems(match.params)}
          />
        </Layouts1>

        <Layouts2 hideScrollbars>
          { renderRoutes({
            routes: route.routes,
            extraProps: { business, setting },
            location
          }) }
        </Layouts2>
      </LayoutsTwo>

      { props.modal &&
        <RubberContractCreateAndUpdateModal {...props} event="create" id="rubberContractCreateAndUpdateModal" business={business} />
      }
    </Window>
  )
}

function mapStateToProps(store, props) {
  return {
    modal: store.app.modals.filter(modal => modal.id === 'rubberContractCreateAndUpdateModal')[0]
  }
}

export default connect(mapStateToProps)(RubberContractsMenuContainer)
